export const BASE_ROUTE = '/';
export const LOGIN_AUTH = '/autenticacion';
export const SYSTEMS_ROUTE = '/sistemas';
export const HOME_ROUTE = '/simac/home';
export const USER_ACCOUNT = '/simac/cuentasUsuario/cuentasUsuario';
export const IDENTIFICACIONSO = '/simac/cuentasUsuario/identificacionSO';
export const MONITOREOS_ROUTE = '/simac/espectaculares/hallazgos';
export const MONITOREOS_ACTA_INICIO_ROUTE = '/simac/espectaculares/actaInicio';
export const MONITOREOS_ACTA_CIERRE_ROUTE = '/simac/espectaculares/actaCierre';
// export const MONITOREOS_HALLAZGOS = '/simac/espectaculares/hallazgos_beta';

export const ERROR_ROUTE = '/error';
export const PAGE_NOT_FOUND_ROUTE = '/pagina-no-encontrada';
export const Sif = process.env.REACT_APP_MENU_UTF;
// export const Sif = 'https://localhost:8543/menuUTF/'; // local
// export const Sif = 'https://sifv6-usu-test.ine.mx/menuUTF/'; // usu
// export const Sif = 'https://sifv6-test.ine.mx/menuUTF/'; // pruebas
// export const Sif = 'https://sifv6-seguridad.ine.mx/menuUTF/'; // seguridad

export const NEW_DEVICE = '/simac/dispositivos/nuevoDispositivo';
export const ASSIGN_DEVICE = '/simac/dispositivos/asignarDispositivo';
export const PROPAGANDA_PUBLICA = '/simac/espectaculares/propagandaViaPublica';
export const MON_MEDIOS_IMPRESOS = '/simac/mediosImpresos';
export const MONITOREOS_INTERNET = '/simac/monitoreosInternet';
export const MON_VISITAS_EVENTOS = '/simac/visitasVerificacion/visitasEventos';
export const MON_VISITAS_CASAS = '/simac/visitasVerificacion/visitasCampania';
export const GEOCERCAS = '/simac/geocercas';
export const DESCARGAS = '/simac/descargas/descargas';

/** Configuración de Catálogos */
export const CONFIGURACION_CATALOGOS = '/simac/configuracionCatalogos';
export const CATALOGO_FECHAS_ROUTE = '/simac/configuracionCatalogos/catalogoFechas';
export const CATALOGO_MEDIOS_IMPRESOS_ROUTE =
  '/simac/configuracionCatalogos/catalogoMediosImpresos';
export const DESCARGAS_PORTAL_ROUTE = '/portal/descargas';
export const CATALOGO_TIPO_MEDIOS_IMPRESOS_ROUTE =
  '/simac/configuracionCatalogos/tiposMediosImpresos';
export const CATALOGO_TIPO_HALLAZGOS_ROUTE = '/simac/configuracionCatalogos/tipoHallazgo';

export const EDICION_PLANTILLAS_ROUTE = '/simac/edicionPlantillas';
export const EDICION_PLANTILLA_SELECCIONADA_ROUTE = '/simac/edicionPlantillas/:idPlantilla';
export const CENTRO_AYUDA = '/simac/centroAyuda';
export const GENERACION_ENLACES = '/simac/descargas/generacionEnlaces';
export const BITACORA_SINCRONIZACION_ROUTE = '/simac/reportes/bitacora';
export const REPORTE_USUARIOS_ROUTE = '/simac/reportes/usuarios';
export const BITACORA_NOTIFICACION_ROUTE = '/simac/reportes/bitacoraNotificaciones';
export const GLUSTER = '/gluster';
